

import { AssessmentResponse } from '@/types/assessment';

/**
 * Generates a basic report when OpenAI is not available
 */
export const generateBasicReport = (responses: AssessmentResponse[] = []): string => {
  return "# Basic Career Guidance Report\n\n" +
    "This is a basic career guidance report based on John L. Holland's RIASEC assessment model.\n\n" +
    "## Assessment Summary\n\n" +
    "You've completed the Holland Code (RIASEC) career assessment questionnaire. Based on your responses, consider exploring careers that align with your indicated personality types and interests.\n\n" +
    "## Next Steps\n\n" +
    "1. Due to network issue we are unable to generate your report - please contact careerguidekerala@gmail.com\n" +
    "2. Explore career paths related to your strongest RIASEC types\n" +
    "3. Consider speaking with a career counselor for personalized guidance based on your Holland Code results";
};

/**
 * Generates a fallback report when OpenAI API fails
 */
export const generateFallbackReport = (categorizedResponses: Record<string, any> = {}): string => {
  return "# Career Guidance Report\n\n" +
    "We encountered an error generating your Holland Code report. Here's a basic summary based on your responses:\n\n" +
    Object.entries(categorizedResponses).map(([category, answers]) => {
      return `## ${category}\n\nYou indicated preferences related to ${category.toLowerCase()} in your responses.\n`;
    }).join('\n') +
    "\n## Career Suggestions Based on RIASEC Model\n\n" +
    "Based on your responses, consider exploring these paths:\n\n" +
    "1. Data Analysis or Business Intelligence (Investigative/Conventional)\n" +
    "2. Digital Marketing (Enterprising/Artistic)\n" +
    "3. Project Management (Enterprising/Conventional)\n" +
    "4. Educational Technology (Social/Investigative)\n\n" +
    "## Next Steps\n\n" +
    "1. Due to network issues we are unable to generate your detailed report - please contact careerguidekerala@gmail.com\n" +
    "2. Connect with professionals in these areas\n" +
    "3. Consider relevant courses or certifications";
};

/**
 * Generates an error report when the whole report generation process fails
 */
export const generateErrorReport = (): string => {
  return "There was an error generating your Holland Code career report. Please contact careerguidekerala@gmail.com for assistance.";
};

